import React from "react";
import '../../css/components/controls/HrnbListGroup.css'

export function HrnbListGroup({ className = "", children, ...props }) {
    return (
        <div className={`hrnb-list-group ${className}`} {...props}>
            {children}
        </div>
    );
}

export function HrnbListGroupItem({
                                      className = "",
                                      icon,
                                      active = false,
                                      disabled = false,
                                      actions,
                                      children,
                                      onClick,
                                      ...props
                                  }) {
    return (
        <div
            className={`hrnb-list-group__item${active ? " hrnb-list-group__item--active" : ""}${disabled ? " hrnb-list-group__item--disabled" : ""} ${className}`}
            tabIndex={disabled ? -1 : 0}
            onClick={disabled ? undefined : onClick}
            {...props}
        >
            {icon && <span className="hrnb-list-group__icon">{icon}</span>}
            <span className="hrnb-list-group__content">{children}</span>
            {actions && <span className="hrnb-list-group__actions">{actions}</span>}
        </div>
    );
}
